import errors from './errors/index.js';
import translation from './translation/index.js';
const vi_vn = {
    translation,
    errors,
};
export default Object.freeze(vi_vn);
